import { IconComponent } from './types';

const Logo: IconComponent = (props) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 13.136c0 1.21-.98 2.191-2.191 2.191h-4.13l-.112-3.27a2.191 2.191 0 0 1 1.297-2.076l.711-.317L16 7.827v5.31Z"
      fill="#FFFA97"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.384 14.597h3.425a1.46 1.46 0 0 0 1.46-1.46V8.92l-3.405 1.413-.702.314a1.46 1.46 0 0 0-.865 1.383l.087 2.566Zm-.705.73h4.13A2.19 2.19 0 0 0 16 13.137v-5.31l-4.425 1.837-.711.317a2.191 2.191 0 0 0-1.297 2.075l.112 3.271Z"
      fill="#212121"
    />
    <path
      d="M6.674 5.543a.243.243 0 0 1-.111-.026L5.072 4.75.44 2.376V2.19C.44.98 1.42 0 2.63 0H5.35c.79 0 1.438.63 1.46 1.42l.108 3.874a.243.243 0 0 1-.243.25Z"
      fill="#98FFD7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.164 4.491 6.079 1.44a.73.73 0 0 0-.73-.71H2.632c-.721 0-1.32.523-1.44 1.21l4.972 2.551ZM.44 2.376V2.19C.44.98 1.42 0 2.63 0H5.35c.79 0 1.438.63 1.46 1.42l.108 3.874a.243.243 0 0 1-.354.223L.44 2.376Z"
      fill="#212121"
    />
    <path
      d="M9.611 8.458a.306.306 0 0 1-.418-.285V0h4.616C15.019 0 16 .981 16 2.191v3.753L9.611 8.458Z"
      fill="#60855C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m9.923 7.55 5.347-2.103V2.19a1.46 1.46 0 0 0-1.461-1.46H9.923v6.82ZM16 5.944 9.611 8.458a.306.306 0 0 1-.418-.285V0h4.616C15.019 0 16 .981 16 2.191v3.753Z"
      fill="#212121"
    />
    <path
      d="M6.386 15.327H2.632a2.19 2.19 0 0 1-2.191-2.19V4.238l3.55 1.823 1.868.967a1.826 1.826 0 0 1 .982 1.748l-.455 6.55Z"
      fill="#FFA063"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m5.705 14.597.407-5.87a1.095 1.095 0 0 0-.589-1.049l-1.865-.966-.003-.001-2.484-1.276v7.701c0 .807.654 1.46 1.46 1.46h3.074ZM.44 13.137c0 1.21.98 2.19 2.19 2.19h3.755l.455-6.55a1.826 1.826 0 0 0-.982-1.748l-1.868-.967L.441 4.24v8.897Z"
      fill="#212121"
    />
  </svg>
);

export default Logo;
